var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7 1.135V3.2c0 .28 0 .42.054.527a.5.5 0 0 0 .219.219C7.38 4 7.52 4 7.8 4h2.065M8 6.5H4m4 2H4m1-4H4M7 1H4.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656C2 2.139 2 2.559 2 3.4v5.2c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.656c.32.163.74.163 1.581.163h3.2c.84 0 1.26 0 1.581-.164a1.5 1.5 0 0 0 .656-.655C10 9.861 10 9.441 10 8.6V4z"
})));
export { SvgFileIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/FileIcon.1354288f1709f17129c80dfb68e83ee4.svg";